import { Component, Inject, OnInit } from '@angular/core';
import { LicenseService } from 'src/app/services/license-selfie.service';
import { disableDebugTools, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { LicenseDetailComponent } from './license-detail/license-detail.component';
import { GlobalService } from 'src/app/services/global.service';
import { DocumentsService } from 'src/app/services/documents.service';
import { VehicleRentDetailComponent } from './vehicle-rent-detail/vehicle-rent-detail.component';

@Component({
  selector: 'app-vehicle-rent',
  templateUrl: './vehicle-rent.component.html',
  styleUrls: ['./vehicle-rent.component.css']
})
export class VehicleRentComponent implements OnInit {
  displayedColumns:Array<string>=["id", "name","company","plate","brand","model","year","price","status"];
  vehicleRents:any;
  openedVehicleRent: any = {};
  constructor(
    private globalService: GlobalService,
    private documentService: DocumentsService,
    private dialog:MatDialog,

    ) { }

  ngOnInit(): void {
    this.getAllVehicleRents();
  }
  
  getAllVehicleRents() {
    this.documentService.getVehicleRentApprovals().subscribe((result:any) => {
        this.vehicleRents = result.data;
        // this.tableClick(this.vehicleRents[0]);
    }, this.globalService.handleError);
  }




  tableClick(row:any) {
    const dialogRef = this.dialog.open(VehicleRentDetailComponent, {
      width: '80%',
      maxHeight: '95vh',
      data: row
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      this.getAllVehicleRents();
    });
  }


}

